import { useTranslation } from "react-i18next";
import { UserStats } from "../api/users";
import { card, panelHeading } from "../styles";
import StatBox from "./league/StatBox";

interface Props {
  stats: UserStats;
  createdAt: string;
}

export default function UserStatsCard({ stats, createdAt }: Props) {
  const { t } = useTranslation();

  // Pinned to en-GB rather than the runtime's OS/ICU locale — the app is
  // English-only today (no locale switcher shipped), so date formatting
  // shouldn't silently follow whatever language the visitor's OS is set to.
  const memberSinceDate = new Date(createdAt).toLocaleDateString("en-GB", {
    day: "numeric", month: "long", year: "numeric",
  });

  return (
    <section style={card}>
      <h2 style={panelHeading}>
        {t("profile.stats")}
      </h2>
      {/* Member since */}
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "0.3rem 0 0.75rem",
        borderBottom: "1px solid var(--color-border-subtle)",
        marginBottom: "0.75rem",
      }}>
        <span style={{ fontSize: "0.85rem", color: "var(--color-text-muted)" }}>{t("profile.memberSince")}</span>
        <span style={{ fontSize: "0.85rem", fontWeight: 500 }}>{memberSinceDate}</span>
      </div>

      {/* Stat tiles */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.6rem" }}>
        <StatBox label={t("profile.victories")}        value={stats.victoriesCount} color="var(--color-accent)" wrapLabel />
        <StatBox label={t("profile.topThree")}          value={stats.topThreeCount} color="var(--color-accent-2)" wrapLabel />
        <StatBox label={t("profile.completedLeagues")}  value={stats.completedLeaguesCount} color="var(--color-mode-gameweek-challenge)" wrapLabel />
        <StatBox label={t("profile.activeLeagues")}     value={stats.activeLeaguesCount} color="var(--color-success)" wrapLabel />
      </div>
    </section>
  );
}
